import React from 'react';

const LiveModeration = () => {
  return (
    <div className="min-h-screen p-4">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-bold text-white mb-8">Live Moderation</h1>
        <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
          <p className="text-gray-300">Live Moderation wird hier implementiert...</p>
        </div>
      </div>
    </div>
  );
};

export default LiveModeration; 